import { formatToBRL } from "brazilian-values";
import { CheckCircle, Clock } from "lucide-react";

const Modal = ({ data, onClose }) => {
  const statusMap = {
    waiting_payment: "Pendente",
    paid: "Pago",
    shipped: "Enviado"
    // Adicione novos status aqui conforme necessário
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl w-11/12 max-w-4xl p-6 shadow-lg relative max-h-screen overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold"
        >
          ×
        </button>

        <h2 className="text-2xl font-light mb-6 text-gray-800">
          Detalhes da Transação
        </h2>

        {!data ? (
          <div className="flex justify-center items-center py-20">
            <div className="text-center">
              <div className="loader border-t-4 border-blue-500 border-solid rounded-full w-10 h-10 mx-auto animate-spin mb-4" />
              <p className="text-gray-600">Carregando informações...</p>
            </div>
          </div>
        ) : (
          <div className="overflow-x-auto rounded-xl border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
              <thead className="bg-[#f5f4f1] text-gray-700 font-semibold">
                <tr>
                  <th className="px-4 py-3 text-left">Campo</th>
                  <th className="px-4 py-3 text-left">Valor</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                <tr>
                  <td className="px-4 py-3 font-medium">ID</td>
                  <td className="px-4 py-3">{data.id || "—"}</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">ID Transação</td>
                  <td className="px-4 py-3">
                    {data.supplierTransactionId || data.idtransaction || "—"}
                  </td>
                </tr>

                <>
                  {data.paymentStatus && (
                    <tr>
                      <td className="px-4 py-3 font-medium">
                        Status de Pagamento
                      </td>
                      <td className="px-4 py-3">
                        <span
                          className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold ${
                            data.paymentStatus === "paid"
                              ? "bg-green-100 text-green-700"
                              : "bg-yellow-100 text-yellow-700"
                          }`}
                        >
                          {data.paymentStatus === "paid" ? (
                            <CheckCircle className="w-4 h-4" />
                          ) : (
                            <Clock className="w-4 h-4" />
                          )}
                          {statusMap[data.paymentStatus] ||
                            data.paymentStatus ||
                            "—"}
                        </span>
                      </td>
                    </tr>
                  )}
                </>

                {data.paymentMethod && (
                  <tr>
                    <td className="px-4 py-3 font-medium">Modo de Pagamento</td>
                    <td className="px-4 py-3">{data.paymentMethod || "—"}</td>
                  </tr>
                )}
                <tr>
                  <td className="px-4 py-3 font-medium">Valor</td>
                  <td className="px-4 py-3">
                    {formatToBRL(data.amount / 100 || 0)}
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">
                    Taxa de Intermediação
                  </td>
                  <td className="px-4 py-3">
                    {formatToBRL(data.fee / 100 || 0)}
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">Valor Líquido</td>
                  <td className="px-4 py-3">
                    {formatToBRL(data.netAmount / 100 || 0)}
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">Data da Transação</td>
                  <td className="px-4 py-3">
                    {data.transactionDate
                      ? new Date(data.transactionDate).toLocaleString()
                      : data.updatedAt
                      ? new Date(data.updatedAt).toLocaleString()
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <td className="px-4 py-3 font-medium">Criado em</td>
                  <td className="px-4 py-3">
                    {data.createdAt &&
                      new Date(data.createdAt).toLocaleString()}
                  </td>
                </tr>

                <tr className="bg-[#f5f4f1] text-sm text-gray-700 font-semibold">
                  <td colSpan={2} className="px-4 py-3">
                    Dados do Cliente
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">Nome</td>
                  <td className="px-4 py-3">{data.customer?.name || "—"}</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">Email</td>
                  <td className="px-4 py-3">{data.customer?.email || "—"}</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">Telefone</td>
                  <td className="px-4 py-3">{data.customer?.phone || "—"}</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">Documento</td>
                  <td className="px-4 py-3">
                    {data.customer?.document?.number || "—"}
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">Endereço</td>
                  <td className="px-4 py-3">
                    {[
                      data.shipping?.street,
                      data.shipping?.city,
                      data.shipping?.state
                    ]
                      .filter(Boolean)
                      .join(", ") || "—"}
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-medium">CEP</td>
                  <td className="px-4 py-3">{data.shipping?.zipCode || "—"}</td>
                </tr>

                {data.items?.length > 0 && (
                  <>
                    <tr className="bg-[#f5f4f1] text-sm text-gray-700 font-semibold">
                      <td colSpan={2} className="px-4 py-3">
                        Itens Comprados
                      </td>
                    </tr>
                    {data.items.map((item, idx) => (
                      <tr key={idx}>
                        <td className="px-4 py-3 font-medium">{item.title}</td>
                        <td className="px-4 py-3">
                          Quantidade: {item.quantity}
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
        )}

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="bg-[#e9dfd0] text-black px-6 py-2 rounded-md hover:bg-[#e9dfd0] transition-all"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
